import ClientDocumentItem from './ClientDocumentItem';

export default ClientDocumentItem;
